(function () {
  /* Guardia: este archivo lo piden dos partes del tema (la ficha y la seccion
     de destacados). Si ya corrio una vez, la segunda copia se apaga sola. */
  if (window.__ssacListo) return;
  window.__ssacListo = true;
  var TAG = '[stepstyle-cart]';
  var TIMEOUT = 15000;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function pick(html, selector) {
    try {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    } catch (err) { return null; }
  }

  /* ---------- red con tope de tiempo ---------- */

  function timedFetch(url, opts) {
    opts = opts || {};
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    if (ctl) opts.signal = ctl.signal;

    var timer = window.setTimeout(function () {
      if (ctl) ctl.abort();
    }, TIMEOUT);

    return fetch(url, opts).then(
      function (r) { window.clearTimeout(timer); return r; },
      function (e) { window.clearTimeout(timer); throw e; }
    );
  }

  function post(body) {
    body.append('sections', 'cart-drawer,cart-icon-bubble');
    body.append('sections_url', window.location.pathname);

    return timedFetch(root() + 'cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    }).then(function (r) { return r.json(); });
  }

  /* ---------- pintar y abrir el drawer ---------- */

  function isEmptyNow(drawer) {
    return !!drawer.querySelector('.drawer__inner-empty');
  }

  function syncEmpty(drawer) {
    /* El tema marca el estado vacio en <cart-drawer>, pero al actualizar por
       AJAX solo cambia lo de adentro. Lo deducimos del contenido real. */
    drawer.classList.toggle('is-empty', isEmptyNow(drawer));
  }

  function paint(drawer, state) {
    var secs = (state && state.sections) || {};

    var dHtml = secs['cart-drawer'];
    if (dHtml) {
      var src = pick(dHtml, '#CartDrawer');
      var dst = document.querySelector('#CartDrawer');
      if (src && dst) dst.innerHTML = src.innerHTML;
      else console.warn(TAG, 'no pude reemplazar #CartDrawer');
    }

    var bHtml = secs['cart-icon-bubble'];
    if (bHtml) {
      var bsrc = pick(bHtml, '.shopify-section') || pick(bHtml, 'body');
      var bdst = document.getElementById('cart-icon-bubble');
      if (bsrc && bdst) bdst.innerHTML = bsrc.innerHTML;
    }

    syncEmpty(drawer);
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    idleAllButtons();
  }

  function wireClose(drawer) {
    var ov = drawer.querySelector('#CartDrawer-Overlay');
    if (ov && !ov.dataset.ssWired) {
      ov.dataset.ssWired = '1';
      ov.addEventListener('click', function () { closeDrawer(drawer); });
    }
    drawer.querySelectorAll('.drawer__close').forEach(function (btn) {
      if (btn.dataset.ssWired) return;
      btn.dataset.ssWired = '1';
      btn.addEventListener('click', function (ev) {
        if (typeof drawer.close !== 'function') {
          ev.preventDefault();
          closeDrawer(drawer);
        }
        idleAllButtons();
      });
    });
  }

  /* El panel se vuelve a crear cada vez que pintamos el carrito, y un elemento
     recien creado no tiene un estado anterior desde donde animar: el navegador
     lo dibuja directo en su posicion final y la entrada se ve seca. Lo clavamos
     un instante en la posicion cerrada, forzamos el dibujo, y recien ahi lo
     soltamos. Asi la transicion del tema corre completa siempre. */
  function slideIn(drawer) {
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) {
      drawer.classList.add('animate', 'active');
      return;
    }
    inner.style.transition = 'none';
    inner.style.transform = 'translateX(100%)';
    drawer.classList.add('animate', 'active');
    void inner.offsetWidth; /* se dibuja en la posicion cerrada */
    inner.style.transition = '';
    inner.style.transform = '';
  }

  /* Un solo camino para abrir, siempre igual, tenga o no productos el carrito. */
  function openWith(state) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    var wasOpen = drawer.classList.contains('active');

    paint(drawer, state);

    if (!wasOpen) slideIn(drawer);

    wireClose(drawer);

    if (typeof drawer.open === 'function') {
      try {
        drawer.open();
        return true;
      } catch (err) {
        console.warn(TAG, 'el open del tema fallo, abro a mano:', err);
      }
    }

    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return true;
  }

  /* ---------- estado de los botones ---------- */

  function labelOf(btn) {
    return btn.querySelector('[data-sspdp-atc-label]') || btn;
  }

  function idleText(btn) {
    var lab = labelOf(btn);
    if (!btn.dataset.ssIdle) btn.dataset.ssIdle = lab.textContent;
    return btn.dataset.ssIdle;
  }

  function busy(btn, txt) {
    idleText(btn);
    labelOf(btn).textContent = txt;
    btn.disabled = true;
  }

  function idle(btn) {
    if (!btn.dataset.ssIdle) return;
    labelOf(btn).textContent = btn.dataset.ssIdle;
    btn.disabled = false;
    if (btn.dataset.ssGuard) {
      window.clearTimeout(parseInt(btn.dataset.ssGuard, 10));
      delete btn.dataset.ssGuard;
    }
    /* Devolver el boton a la normalidad no puede saltarse el candado del pack:
       si todavia faltan productos por elegir, tiene que quedar bloqueado. */
    applyPackState();
  }

  function idleAllButtons() {
    document.querySelectorAll('[data-sspdp-atc][data-ss-idle]').forEach(idle);
    applyPackState();
    document.dispatchEvent(new CustomEvent('stepstyle:cart-idle'));
  }

  /* Perro guardian: si por lo que sea nadie devuelve el boton a la normalidad,
     lo hacemos nosotros. Un boton pegado en "Agregando..." es una venta menos. */
  function guard(btn) {
    if (btn.dataset.ssGuard) window.clearTimeout(parseInt(btn.dataset.ssGuard, 10));
    btn.dataset.ssGuard = String(window.setTimeout(function () {
      console.warn(TAG, 'el boton quedo ocupado demasiado rato, lo libero');
      idle(btn);
    }, TIMEOUT + 3000));
  }

  function flash(btn, txt, ms) {
    idleText(btn);
    labelOf(btn).textContent = txt;
    window.setTimeout(function () { idle(btn); }, ms);
  }

  /* ---------- red de seguridad del pack ----------
     El bloque del pack se dibuja ANTES que el boton de compra, asi que cuando
     su script arranca el boton todavia no existe en la pagina y no alcanza a
     tomarlo. Por eso el pack nunca lograba bloquear el boton cuando faltaba
     elegir productos, y se podia mandar un pedido incompleto. Esto corre
     despues y lo cubre desde afuera. */

  function packHint() {
    var ssb = document.querySelector('[data-ssb]');
    if (!ssb) return null;
    var radio = ssb.querySelector('[data-ssb-radio]:checked');
    if (!radio || !radio.parentNode || !radio.parentNode.querySelector) return null;
    return radio.parentNode.querySelector('[data-ssb-hint]');
  }

  function packIncomplete() {
    var h = packHint();
    return !!(h && h.classList.contains('is-on'));
  }

  function applyPackState() {
    var ssb = document.querySelector('[data-ssb]');
    var atc = document.querySelector('[data-sspdp-atc]');
    if (!ssb || !atc) return;
    if (atc.dataset.ssGuard) return; /* hay un envio en curso, no lo pisamos */
    var bad = packIncomplete();
    atc.disabled = bad;
    labelOf(atc).textContent = bad ? 'Elige tus productos' : idleText(atc);
  }

  function watchPack() {
    var ssb = document.querySelector('[data-ssb]');
    var atc = document.querySelector('[data-sspdp-atc]');
    if (!ssb || !atc || ssb.dataset.ssWatched === '1') return;
    ssb.dataset.ssWatched = '1';

    idleText(atc); /* guardamos el texto bueno antes de tocarlo */
    applyPackState();

    new MutationObserver(applyPackState).observe(ssb, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'data-ssb-pid']
    });
    ssb.addEventListener('change', function () { window.setTimeout(applyPackState, 0); });
  }

  /* ---------- API ---------- */

  function addItems(items) {
    var list = [].concat(items || []);
    var fd = new FormData();

    list.forEach(function (it, i) {
      fd.append('items[' + i + '][id]', it.id);
      fd.append('items[' + i + '][quantity]', it.quantity || 1);
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          fd.append('items[' + i + '][properties][' + k + ']', it.properties[k]);
        });
      }
    });

    return send(fd);
  }

  function fallo(state) {
    var err = new Error(state.description || state.message || 'No se pudo agregar al carrito');
    err.state = state;
    return err;
  }

  /* Cierre del camino rapido: el estado ya trae el carrito dibujado. */
  function finish(state) {
    if (state && state.status) throw fallo(state);
    openWith(state);
    return state;
  }

  /* Camino de respaldo (el de antes, tres viajes). Solo se usa si en la
     pagina no hay drawer donde mirar si el seguro ya esta adentro. */
  function check(state) {
    if (state && state.status) throw fallo(state);
    return withSeguro(state).then(function (finalState) {
      openWith(finalState);
      return finalState;
    });
  }

  /* ---------- seguro de envio ----------
     El seguro viene ACTIVADO por defecto: cada vez que se agrega algo al
     carrito, si el seguro no esta ya adentro y el cliente no lo desactivo
     en esta visita, se suma solo. El toggle del carrito lo refleja porque
     el tema lee el carrito real (updateCartUpsellToggleState), y apagarlo
     lo saca con el codigo que ya trae el tema.
     Si el seguro falla por lo que sea, el producto principal igual entra:
     nunca dejamos que un extra rompa la compra. */

  var SEGURO_OFF = 'ss-seguro-off';

  function seguroId() {
    var s = document.querySelector('script[data-cart-upsell-variant-id]');
    var id = s ? String(s.dataset.cartUpsellVariantId || '').trim() : '';
    return (id && id !== 'null' && id !== 'undefined') ? id : '';
  }

  function seguroRechazado() {
    try { return sessionStorage.getItem(SEGURO_OFF) === '1'; } catch (e) { return false; }
  }

  /* true = hay que sumarlo, false = no, null = no hay drawer donde mirar.
     Se buscan solo las LINEAS del carrito (el input de cantidad trae el id de
     la variante). El id del seguro tambien aparece en el script del toggle,
     por eso no se busca en todo el drawer. */
  function seguroFalta() {
    var id = seguroId();
    if (!id || seguroRechazado()) return false;
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return null;
    return !drawer.querySelector('.cart-item [data-quantity-variant-id="' + id + '"]');
  }

  /* Camino de respaldo: pregunta al servidor y suma el seguro aparte. */
  function withSeguro(state) {
    var id = seguroId();
    if (!id || seguroRechazado()) return Promise.resolve(state);

    return getCart()
      .then(function (cart) {
        var dentro = (cart.items || []).some(function (it) {
          return String(it.variant_id) === id;
        });
        if (dentro) return state;

        var fd = new FormData();
        fd.append('items[0][id]', id);
        fd.append('items[0][quantity]', 1);

        return post(fd).then(function (st) {
          if (st && st.status) {
            console.warn(TAG, 'no pude agregar el seguro de envio:', st);
            return state;
          }
          return st;
        });
      })
      .catch(function (e) {
        console.warn(TAG, 'seguro de envio:', e);
        return state;
      });
  }

  /* Unidades de cada variante que hoy muestra el drawer. */
  function enDrawer() {
    var out = {};
    document.querySelectorAll('#CartDrawer .cart-item [data-quantity-variant-id]').forEach(function (inp) {
      var k = String(inp.dataset.quantityVariantId);
      out[k] = (out[k] || 0) + (parseInt(inp.value, 10) || 0);
    });
    return out;
  }

  function idsDe(fd) {
    var ids = [];
    fd.forEach(function (v, k) {
      if (/^items\[\d+\]\[id\]$/.test(k) && String(v).trim()) ids.push(String(v).trim());
    });
    return ids;
  }

  function copia(fd) {
    var c = new FormData();
    fd.forEach(function (v, k) { c.append(k, v); });
    return c;
  }

  function siguienteIndice(fd) {
    var max = -1;
    fd.forEach(function (v, k) {
      var m = /^items\[(\d+)\]/.exec(k);
      if (m) max = Math.max(max, parseInt(m[1], 10));
    });
    return max + 1;
  }

  /* Red de seguridad: si el drawer estaba desactualizado (por ejemplo, el
     seguro se agrego en otra pestana) y el seguro quedo con 2 unidades, se
     deja en 1. Casi nunca pasa; cuando pasa cuesta un viaje extra. */
  function corregirSeguro(state) {
    var id = seguroId();
    var linea = null;
    ((state && state.items) || []).forEach(function (it) {
      if (String(it.variant_id) === id) linea = it;
    });
    if (!linea || !(linea.quantity > 1) || !linea.key) return Promise.resolve(state);

    console.warn(TAG, 'el seguro quedo repetido, lo dejo en 1');
    return timedFetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: linea.key,
        quantity: 1,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return (cart && cart.sections) ? cart : state; })
      .catch(function () { return state; });
  }

  /* El envio rapido: productos + seguro en UNA peticion, carrito dibujado
     UNA vez. */
  function send(fd) {
    var falta = seguroFalta();

    if (falta === null) return post(fd).then(check);
    if (!falta) return post(fd).then(finish);

    var antes = enDrawer();
    var ids = idsDe(fd);
    var conSeguro = copia(fd);
    var n = siguienteIndice(conSeguro);
    conSeguro.append('items[' + n + '][id]', seguroId());
    conSeguro.append('items[' + n + '][quantity]', 1);

    return post(conSeguro).then(function (state) {
      if (!(state && state.status)) return corregirSeguro(state).then(finish);

      /* Fallo el envio conjunto. El seguro nunca puede romper la compra:
         se reintenta solo con los productos, pero antes se confirma que no
         hayan entrado igual, para no duplicarlos. */
      console.warn(TAG, 'fallo el envio con seguro, reintento sin seguro:', state);
      return getCart().then(function (cart) {
        var ahora = {};
        (cart.items || []).forEach(function (it) {
          var k = String(it.variant_id);
          ahora[k] = (ahora[k] || 0) + it.quantity;
        });
        var entraron = ids.some(function (k) { return (ahora[k] || 0) > (antes[k] || 0); });
        if (entraron) return openCart().then(function () { return cart; });
        return post(fd).then(finish);
      });
    });
  }

  /* Si el cliente lo apaga, se respeta por el resto de la visita.
     Va en fase de CAPTURA a proposito: el tema escucha el cambio en el propio
     checkbox y llama a stopImmediatePropagation(), asi que un listener normal
     en document nunca se enteraria de que lo apagaron. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.id !== 'cart-upsell-toggle') return;
    try { sessionStorage.setItem(SEGURO_OFF, t.checked ? '0' : '1'); } catch (err) {}
  }, true);

  /* El pack manda sus lineas como items[n][id]. Si ademas viaja el campo "id"
     suelto del formulario, Shopify recibe dos formas de pedir lo mismo en la
     misma peticion y puede terminar agregando lineas de mas. Mandamos una
     sola forma, siempre.
     Un formulario simple (sin pack) se pasa al mismo formato items[0], asi el
     seguro puede viajar en la misma peticion. */
  function normalize(fd) {
    var hasItems = false;
    fd.forEach(function (v, k) {
      if (/^items\[\d+\]\[id\]$/.test(k) && String(v).trim()) hasItems = true;
    });
    if (hasItems) {
      if (fd.has('id')) fd.delete('id');
      return fd;
    }
    if (!fd.has('id') || !String(fd.get('id')).trim()) return fd;

    var out = new FormData();
    out.append('items[0][id]', fd.get('id'));
    out.append('items[0][quantity]', fd.get('quantity') || 1);
    fd.forEach(function (v, k) {
      if (k === 'id' || k === 'quantity') return;
      var m = /^properties\[(.+)\]$/.exec(k);
      if (m) { out.append('items[0][properties][' + m[1] + ']', v); return; }
      if (k === 'selling_plan') {
        if (String(v).trim()) out.append('items[0][selling_plan]', v);
        return;
      }
      out.append(k, v);
    });
    return out;
  }

  /* Manda un formulario de compra completo (arrastra los inputs del pack).
     Si ya hay un envio de ese mismo formulario en vuelo, no manda otro. */
  function addForm(form) {
    if (form.dataset.ssBusy === '1') {
      return Promise.reject(new Error('Ya hay un envio en curso'));
    }
    form.dataset.ssBusy = '1';

    function free() { delete form.dataset.ssBusy; }

    return send(normalize(new FormData(form))).then(
      function (state) { free(); return state; },
      function (err) { free(); throw err; }
    );
  }

  function openCart() {
    return timedFetch(root() + '?sections=cart-drawer,cart-icon-bubble', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (sections) { return openWith({ sections: sections }); });
  }

  /* ---------- abrir el carrito al instante ----------
     El panel del carrito YA viene dibujado dentro de la pagina, asi que se
     puede mostrar de inmediato. Antes, al tocar el icono de la bolsa, primero
     se le pedia el carrito al servidor y el panel no aparecia hasta que
     llegara la respuesta: medio segundo largo en wifi y bastante mas en datos
     moviles, con el carrito vacio o lleno, daba lo mismo.
     Ahora se abre al tiro y la comprobacion contra el servidor corre por
     detras: si algo cambio se repinta, y si no, no se toca nada. */
  function abrirAlTiro() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    if (!drawer.classList.contains('active')) slideIn(drawer);
    syncEmpty(drawer);
    wireClose(drawer);

    if (typeof drawer.open === 'function') {
      try {
        drawer.open();
        return true;
      } catch (err) {
        console.warn(TAG, 'el open del tema fallo, abro a mano:', err);
      }
    }

    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    return true;
  }

  /* Firma del carrito: que variantes hay y cuantas unidades de cada una.
     Se compara el carrito de verdad (el del servidor) contra el que ya se ve
     dibujado. No se compara el HTML porque el propio tema le hace cambios
     cosmeticos despues de dibujarlo (mueve el ahorro, envuelve las lineas,
     reescribe el titulo) y entonces SIEMPRE saldria distinto, obligando a
     repintar de gusto en cada apertura. */
  function firmaDelDrawer() {
    var out = [];
    document.querySelectorAll('#CartDrawer .cart-item [data-quantity-variant-id]').forEach(function (inp) {
      out.push(String(inp.dataset.quantityVariantId) + ':' + (parseInt(inp.value, 10) || 0));
    });
    return out.sort().join(',');
  }

  function firmaDelCarrito(cart) {
    var out = ((cart && cart.items) || []).map(function (it) {
      return String(it.variant_id) + ':' + it.quantity;
    });
    return out.sort().join(',');
  }

  /* Corre DESPUES de abrir, sin que el cliente espere. Solo repinta si el
     carrito cambio fuera de esta pestana (otra pestana, una app, una sesion
     vieja). En el caso normal no toca nada y no hay ningun parpadeo. */
  function revisarEnSegundoPlano() {
    return getCart()
      .then(function (cart) {
        if (firmaDelCarrito(cart) === firmaDelDrawer()) return null;

        console.warn(TAG, 'el carrito cambio fuera de esta pestana, lo actualizo');
        return timedFetch(root() + '?sections=cart-drawer,cart-icon-bubble', {
          headers: { 'Accept': 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            var drawer = document.querySelector('cart-drawer');
            if (!drawer) return null;
            paint(drawer, { sections: sections });
            wireClose(drawer);
            return sections;
          });
      })
      .catch(function (err) {
        console.warn(TAG, 'no pude revisar el carrito en segundo plano:', err);
      });
  }

  function getCart() {
    return timedFetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  window.StepStyleCart = {
    add: addItems,
    addForm: addForm,
    openCart: openCart,
    getCart: getCart,
    open: openWith,
    idleButtons: idleAllButtons,
    hasDrawer: function () { return !!document.querySelector('cart-drawer'); }
  };

  /* ---------- eventos ---------- */

  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('cart-drawer.active');
    if (!d) return;
    if (typeof d.close !== 'function') closeDrawer(d);
    idleAllButtons();
  });

  /* Fase de captura + corte inmediato: nadie mas maneja este envio. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;

    var btn = form.querySelector('[data-sspdp-atc]');
    if (!btn && form.id !== 'sspdp-form') return;

    if (!document.querySelector('cart-drawer')) {
      console.warn(TAG, 'no hay <cart-drawer> en la pagina, va al carrito normal');
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    if (form.dataset.ssBusy === '1') {
      console.warn(TAG, 'ya hay un envio en curso, ignoro este');
      return;
    }

    if (packIncomplete()) {
      console.warn(TAG, 'el pack esta incompleto, no mando nada');
      if (btn) flash(btn, 'Elige tus productos', 2200);
      var ssb = document.querySelector('[data-ssb]');
      if (ssb) ssb.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (btn) {
      busy(btn, 'Agregando…');
      guard(btn);
    }

    addForm(form)
      .then(function () {
        if (btn) idle(btn);
      })
      .catch(function (err) {
        if (!btn) { console.warn(TAG, err); return; }

        if (err && err.state) {
          console.warn(TAG, 'Shopify rechazo el add:', err.state);
          btn.disabled = false;
          flash(btn, err.message, 2800);
          return;
        }

        console.warn(TAG, 'fallo la peticion:', err);
        btn.disabled = false;
        flash(btn, 'No se pudo agregar, intenta de nuevo', 2800);
      });
  }, true);

  /* Si el navegador restaura la pagina desde el cache (volver atras), ningun
     boton debe quedar en estado ocupado. */
  window.addEventListener('pageshow', idleAllButtons);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchPack);
  else watchPack();
  document.addEventListener('shopify:section:load', function () { window.setTimeout(watchPack, 0); });

  /* ---------- FIX: botones "Agregar al carrito" de los Jibbitz ----------
     Antes esos botones agregaban con su propio fetch y solo actualizaban el
     numerito del icono: el drawer se quedaba con el HTML viejo (vacio), asi
     que al abrir el carrito salia "no agregaste nada" aunque el pin si estaba.
     Ahora pasan por el mismo camino que el boton principal: agregan, dibujan
     el carrito con lo que hay de verdad y lo abren. Va en fase de CAPTURA y
     corta ahi mismo para que el fetch viejo de la ficha ya no se dispare. */
  document.addEventListener('click', function (e) {
    var jb = e.target.closest ? e.target.closest('[data-ssjb-add]') : null;
    if (!jb) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (jb.dataset.ssBusy === '1') return;
    jb.dataset.ssBusy = '1';

    if (!jb.dataset.ssText) jb.dataset.ssText = jb.textContent;
    var prev = jb.dataset.ssText;
    jb.textContent = 'Agregando…';

    function volver(ms) {
      window.setTimeout(function () {
        jb.textContent = prev;
        jb.classList.remove('is-done');
        delete jb.dataset.ssBusy;
      }, ms);
    }

    addItems([{ id: parseInt(jb.dataset.ssjbAdd, 10), quantity: 1 }])
      .then(function () {
        jb.textContent = 'Agregado ✓';
        jb.classList.add('is-done');
        volver(1800);
      })
      .catch(function (err) {
        console.warn(TAG, 'no pude agregar el jibbitz:', err);
        jb.textContent = (err && err.state && err.message) ? err.message : 'No se pudo agregar';
        volver(2600);
      });
  }, true);

  /* ---------- el icono del carrito abre al instante ----------
     Se abre con lo que ya esta dibujado y, en paralelo, se comprueba con el
     servidor por si algo cambio fuera de esta pestana (otra pestana, una app).
     Asi el cliente nunca espera para ver su carrito. */
  document.addEventListener('click', function (e) {
    var icon = e.target.closest ? e.target.closest('#cart-icon-bubble') : null;
    if (!icon || !document.querySelector('cart-drawer')) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    if (!abrirAlTiro()) {
      window.location.href = root() + 'cart';
      return;
    }
    revisarEnSegundoPlano();
  }, true);
})();